import { useMemo } from 'react';
import { deleteUndefinedValues } from '@/utils/objects';
import { useTheme } from '@/components/widget/Layout/ThemeProvider';

const mapThemeStylesToSectionStyles = elements => {
  return deleteUndefinedValues({
    chartBackgroundColor: elements.color.bodyBackground,
    listItemVerticalPadding: elements.list.item.verticalPadding,
    listItemHorizontalPadding: elements.list.item.horizontalPadding,
    listItemLabelColor: elements.list.item.label.color,
    listItemTextColor: elements.list.item.text.color,
    listItemFontSize: elements.list.item.fontSize
  });
};

export const useListStyles = () => {
  const themeCtx = useTheme();
  const defaultStyles = useMemo(() => mapThemeStylesToSectionStyles(themeCtx.theme.elements || {}), [themeCtx]);
  return {
    defaultStyles,
    themeCtx
  };
};